import { localDate } from "../daily.ts";
import { landingText } from "../game/text.ts";
import type { PageData } from "../page.ts";
import { h } from "./dom.ts";

export function showLanding(root: HTMLElement, data: PageData, onStart: () => void | Promise<void>): void {
  const text = landingText(data.challenge, data.puzzle.date === localDate());
  const start = h("button", { class: "primary", type: "button" }, "Take the challenge");
  const problem = h("p", { class: "error small center", role: "alert" });
  let starting = false;
  start.addEventListener("click", async () => {
    if (starting) return;
    starting = true;
    start.setAttribute("aria-disabled", "true");
    problem.textContent = "";
    try {
      await onStart();
    } catch {
      problem.textContent = "The game didn't load. Check your connection and try again.";
      starting = false;
      start.removeAttribute("aria-disabled");
      start.focus();
    }
  });
  root.replaceChildren(
    h("div", { class: "page landing" },
      h("header", { class: "brand" },
        h("p", { class: "wordmark" }, "Where in the World?"),
        h("p", { class: "mono muted" }, "FREE · NO SIGN-UP")),
      h("p", { class: "mono accent eyebrow" }, text.eyebrow),
      h("h1", { class: "serif" }, text.heading),
      h("img", { class: "landing-photo", src: data.puzzle.image.url, alt: data.puzzle.alt }),
      h("p", { class: "mono muted pin" }, "Location hidden"),
      start,
      problem,
      h("p", { class: "soft small center" }, "About 2 minutes. Six guesses. Plays right here in your browser.")),
  );
  start.focus();
}
